import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";
import { BsClockHistory } from "react-icons/bs";
import { PiWarning } from "react-icons/pi";

const QueryStatusDistribution = ({ taskAnalytics = {} }) => {
  const series = [
    Number(taskAnalytics?.totalOpenComment || 0),
    Number(taskAnalytics?.totalClosedComment || 0),
  ];

  const total = series.reduce((a, b) => a + b, 0);

  const queryPercentage =
    total > 0
      ? Math.round(
        ((taskAnalytics?.totalOpenComment || 0) / total) * 100
      )
      : 0;

  const chartOptions = {
    chart: {
      type: "donut",
    },
    colors: ["#ef4444", "#22c55e"],
    labels: [
      "Open Query",
      "Closed Query",
    ],
    stroke: {
      width: 0,
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "72%",
          labels: {
            show: true,
            value: {
              show: true,
              fontSize: "15px",
              fontWeight: 700,
              formatter: () => `${queryPercentage}%`,
            },
            total: {
              show: true,
              label: "OPEN",
              fontSize: "10px",
              fontWeight: 600,
              color: "#64748b",
            },
          },
        },
      },
    },
  };

  const statusData = [
    {
      name: "Open Query",
      value: Number(taskAnalytics?.totalOpenComment || 0),
      color: "#ef4444",
    },
    {
      name: "Closed Query",
      value: Number(taskAnalytics?.totalClosedComment || 0),
      color: "#22c55e",
    }
  ];

  return (
    <div className="app-card shadow-md border br3 bg-light h-100">
      <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
        <Form.Label className="m-0 text-nowrap bold">
          <PiWarning className="me-2 text-danger" />
          Query Status Distribution
        </Form.Label>

        <small className="text-secondary">
          {total} Query
        </small>
      </div>

      <div className="p-2 hstack gap-4 w-100">
        <Chart
          options={chartOptions}
          series={series}
          type="donut"
          height={150}
        />

        <div className="w-100">
          {statusData.map((item) => (
            <div
              key={item.name}
              className="hstack justify-content-between mb-1 w-100"
            >
              <div className="hstack">
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: item.color,
                    display: "inline-block",
                    marginRight: 12,
                  }}
                />
                <small style={{ fontSize: 13 }}>
                  {item.name}
                </small>
              </div>

              <div className="hstack gap-2">
                <small className="fw-bold">
                  {item.value}
                </small>

                <small className="text-secondary">
                  {total > 0
                    ? Math.round((item.value / total) * 100)
                    : 0}
                  %
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QueryStatusDistribution;